module.exports = __webpack_public_path__ + "static/media/cs1.57887f56.jpg";